import { useEffect, useState } from 'react';

import { ContentTypeContainerService } from '@confluence/content-types-bridge/entry-points/content-types-container-service';
import { WIKI } from '@confluence/named-routes';

import type { UseSpaceQueryResult } from './graphql/useSpace';

export const useContainerService = (space: UseSpaceQueryResult, spaceKey: string) => {
	const [containerService] = useState(() => new ContentTypeContainerService());

	// Update the current container whenever the space changes
	useEffect(() => {
		if (!space.name || !space.iconPath) {
			return;
		}

		containerService.updateContainer({
			key: spaceKey,
			name: space.name,
			iconPath: `${WIKI.pattern}/${space.iconPath}`,
		});

		return () => containerService.resetContainer();
	}, [containerService, space.name, spaceKey, space.iconPath]);

	return containerService;
};
